export const block_SplitButton = "KH7Bcd";
export const delete_SplitButton = "GuWIP";
export const flagUnflag_SplitButton = "Uio6Ec";
export const newMessage_SplitButton = "Smkiub";
export const report_SplitButton = "fQ9_Bb";
export const respond_SplitButton = "eDbMUb";
export const respondForward_SplitButton = "pfSmc";
export const replyCopilotMeetingToEmail_SplitButton = "PIPM0b";
export const viewGroups_SplitButton = "ajN8Ed";
export default {block_SplitButton,delete_SplitButton,flagUnflag_SplitButton,newMessage_SplitButton,report_SplitButton,respond_SplitButton,respondForward_SplitButton,replyCopilotMeetingToEmail_SplitButton,viewGroups_SplitButton};